import { Card, CardContent, CardHeader, CardTitle } from "@/components/ui/card";
import { Badge } from "@/components/ui/badge";
import { Clock, ArrowRight } from "lucide-react";
import type { Database } from "@/integrations/supabase/types";

type VersionEntry = Database["public"]["Tables"]["sentinel_version_history"]["Row"];

interface VersionTimelineProps {
  entries: VersionEntry[];
}

export function VersionTimeline({ entries }: VersionTimelineProps) {
  if (entries.length === 0) {
    return (
      <Card><CardContent className="py-12 text-center">
        <Clock className="w-10 h-10 text-muted-foreground mx-auto mb-3" />
        <p className="text-sm text-muted-foreground">Nenhum histórico de versão disponível.</p>
      </CardContent></Card>
    );
  }

  return (
    <Card>
      <CardHeader className="pb-2">
        <CardTitle className="text-sm font-medium flex items-center gap-2">
          <Clock className="w-4 h-4 text-muted-foreground" />
          Histórico de Versões
        </CardTitle>
      </CardHeader>
      <CardContent>
        <div className="relative space-y-0">
          {entries.map((entry, i) => (
            <div key={entry.id} className="flex gap-3 pb-4 relative">
              {/* Timeline line */}
              {i < entries.length - 1 && (
                <div className="absolute left-[7px] top-5 bottom-0 w-px bg-border" />
              )}
              {/* Dot */}
              <div className="w-[15px] h-[15px] rounded-full border-2 border-primary bg-background shrink-0 mt-0.5 z-10" />
              {/* Content */}
              <div className="flex-1 min-w-0">
                <div className="flex items-center gap-2 flex-wrap mb-0.5">
                  <Badge variant="outline" className="text-[10px]">{entry.entity_type}</Badge>
                  {entry.from_state && (
                    <>
                      <span className="text-xs text-muted-foreground">{entry.from_state}</span>
                      <ArrowRight className="w-3 h-3 text-muted-foreground" />
                    </>
                  )}
                  <span className="text-xs font-medium text-foreground">{entry.to_state}</span>
                </div>
                {entry.reason && <p className="text-xs text-muted-foreground">{entry.reason}</p>}
                <div className="flex items-center gap-2 mt-0.5">
                  {entry.actor && <span className="text-[10px] text-muted-foreground">por {entry.actor}</span>}
                  <span className="text-[10px] text-muted-foreground">{new Date(entry.created_at).toLocaleString("pt-BR")}</span>
                </div>
              </div>
            </div>
          ))}
        </div>
      </CardContent>
    </Card>
  );
}
